import {
  EntityHistory,
  SharedHistoryEvents,
  UnifiedHistoryEvents,
} from '@texas/api/historyTypes';
import { TFunction } from 'i18next';

export function getHistoryText(
  history: EntityHistory<SharedHistoryEvents>,
  t: TFunction,
) {
  const type = history.eventType as unknown as keyof UnifiedHistoryEvents;

  return t(`history.types.${type}`, {
    from: history.from,
    to: history.to,
    name: history.referenceName,
  });
}
